/**
 * The persistent preview notice (#25 / R5.3).
 *
 * `tokens.json` requires a "persistent preview notice" in fixture mode. Persistent means it cannot
 * be dismissed: there is deliberately no close control. A dismissible banner is absent from exactly
 * the screenshot that needed it.
 *
 * It renders above the surface, in normal document flow rather than as an overlay, so it cannot
 * cover a control or change what a surface's own layout does below it.
 */
import React from 'react';
import { Link } from 'react-router-dom';

const bar = {
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  gap: '0.75rem',
  padding: '0.5rem 1rem',
  borderBottom: '1px solid var(--line, #bdb1a2)',
  background: 'var(--gold-wash, #f4e5c5)',
  color: 'var(--gold-ink, #634119)',
  font: 'inherit',
  fontSize: '0.875rem',
};

export default function FixtureBanner() {
  return (
    <div style={bar} role="note" aria-label="Preview notice" data-fixture-banner="true">
      <strong>Preview.</strong>
      <span>Fixture data. No server. Nothing here can be saved.</span>
      <Link to="/gallery" style={{ marginLeft: 'auto', minHeight: '44px', lineHeight: '44px' }}>
        All surfaces
      </Link>
    </div>
  );
}
